import React from 'react';

import { observer } from 'mobx-react';
import { Button } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
  UserInfoCell,
} from '../../../../shared/components/table-components';
import { getFormattedDate } from '../../../../shared/utils/dateUtils';
import { dateFormat, localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { ScanIqCustomerListInfo } from '../../../interfaces/ScanIqCustomerListInfo';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { openModal } from '../../../../shared/utils/reactUtils/openModal/openModal';
import { GenerateReportModal } from '../../../../inbody';
import goHighLevelLogo from '../../../../shared/assets/image/goHighLevelLogo.webp';

type CustomerRowProps = {
  customerInfo: ScanIqCustomerListInfo;
};

const CustomerRow = observer(({ customerInfo }: CustomerRowProps) => {
  const { isSuperAdmin } = loggedInUserDataStore;

  const {
    id,
    entityId,
    gymName,
    firstName,
    lastName,
    email,
    phone,
    initialScanDate,
    lastScanDate,
    ghlContactId,
  } = customerInfo;

  // incomplete (NEED_SETUP) customers may miss name/email
  const customerName = [firstName, lastName].filter(Boolean).join(' ');

  const isGHLConnected = !!ghlContactId;

  const handleOpenGenerateReportModal = () => {
    openModal((closeModal) => (
      <GenerateReportModal
        customerId={id}
        entityId={entityId}
        customerName={{ firstName, lastName }}
        onClose={closeModal}
      />
    ));
  };

  return (
    <GridTableRow variant="row" highlight={customerInfo.newScansAvailable}>
      <UserInfoCell
        name={customerName || 'No name provided'}
        email={email ?? 'No email provided'}
        phone={phone ?? 'No phone provided'}
        href={`#!/customer-profile/scan-iq/${entityId}/${id}`}
        nameAdornment={
          isGHLConnected && (
            <img src={goHighLevelLogo} alt="GoHighLevel logo" width={16} />
          )
        }
      />
      {isSuperAdmin && (
        <GridTableCell dataTestId="entity-name-cell">{gymName}</GridTableCell>
      )}
      <GridTableCell dataTestId="registration-date-cell">
        {initialScanDate
          ? getFormattedDate(initialScanDate, localDataFormat, dateFormat)
          : '-'}
      </GridTableCell>
      <GridTableCell dataTestId="registration-date-cell">
        {lastScanDate ? getFormattedDate(lastScanDate, localDataFormat, dateFormat) : '-'}
      </GridTableCell>
      <Button
        variant="contained"
        size="small"
        disabled={!lastScanDate}
        onClick={handleOpenGenerateReportModal}
      >
        Generate Report
      </Button>
    </GridTableRow>
  );
});

export { CustomerRow };
